import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ToggleOptionComponent } from './toggle-option.component';

@NgModule({
	declarations: [
		ToggleOptionComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		ToggleOptionComponent
	]
})
export class ToggleOptionModule {}
